// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__F1MEz","tab":"style_tab__1Gs2t"};